module.exports = __webpack_public_path__ + "img/organized-fr-ca.56259319.jpg";